
import React, { useState, useEffect } from 'react';
import { Col, Container, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import { motion } from "framer-motion";
import { FaSearch, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import products from "../../../assets/images/hero/products.png";
import prod from "../../../assets/images/hero/bamboobg.png";
import prods from "../../../assets/images/hero/img.png";
import Vending_machine from "../../../assets/images/hero/shared image.png";
import background1 from "../../../assets/images/hero/brianjtrompiapne9_baumunsplash1.png";
import background2 from "../../../assets/images/hero/housekeep.png";
import background3 from "../../../assets/images/hero/Home3.png";
const contentData = [
    {
        title: "Everything Your Office Needs ",
        highlight: "All in One Place",
        description: "Streamlining Office Supplies, Housekeeping, Corporate Gifting, Coffee Solutions, and More.",
        image: products,
        titleColor: "rgb(49, 81, 162)",
        highlightColor: "rgb(241, 90, 41)",
        descriptionColor: "rgb(49, 81, 162)",

    },
    {
        title: "Everything Your Office Needs ",
        highlight: "All in One Place",
        description: "From Tata and Nescafé vending machines to snack dispensers, sanitary pad vending machines, cleaning chemicals, stationery, and plants on rent – we cover all your workplace necessities with ease.",
        backgroundImage: prod,
        image: prods,
        titleColor: "rgb(49, 81, 162)",
        highlightColor: "rgb(241, 90, 41)",
        descriptionColor: "rgb(49, 81, 162)",

    },
    {
        title: "You got it!!!",
        highlight: "All in One Place",
        description: "Coffee Vending Machine, Coffee Powder, Tetra Pack Milk, Sugar Sachet, Paper Cup, Wooden Stirrer and more",
        backgroundImage: background3,
        image: Vending_machine,
        showSearchBar: true,
        searchPlaceholder: "Coffee Vending Machine near me",
        titleColor: "black",
        highlightColor: "rgb(241, 90, 41)",
        descriptionColor: "black",
        backgroundOpacity: 1.1
    },
    {
        title: "You got it!!!",
        highlight: "All in One Place",
        description: "Floor Cleaner, Handwash, Toilet Rolls, Multifold Tissue, Facial Tissue Box, Toilet Cubes, Glass Cleaner and more",
        backgroundImage: background2,
        showSearchBar: true,
        searchPlaceholder: "Housekeeping Service near me",
        titleColor: "rgb(49, 81, 162)",
        highlightColor: "rgb(241, 90, 41)",
        descriptionColor: "rgb(49, 81, 162)",
        backgroundOpacity: 1
    },
    {
        title: "You got it!!!",
        highlight: "All in One Place",
        description: "Aglonema Plant, Areca Palm Plant, Dressina Plant, Frangrance Plant, Machera Plant, Table Palm Plant, Rubber Tree, Dressina Carmen and more.",
        backgroundImage: background1,
        showSearchBar: true,
        searchPlaceholder: "Plant on rent service near me",
        titleColor: "black",
        highlightColor: "rgb(240, 67, 9)",
        descriptionColor: "black",
        backgroundOpacity: 1.1
    },
];

const Home = () => {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const timer = setInterval(() => {
            setIndex((prevIndex) => (prevIndex + 1) % contentData.length);
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    const handlePrev = () => {
        setIndex((prevIndex) => (prevIndex - 1 + contentData.length) % contentData.length);
    };

    const handleNext = () => {
        setIndex((prevIndex) => (prevIndex + 1) % contentData.length);
    };

    const { title, highlight, description, image, backgroundImage, showSearchBar, searchPlaceholder, titleColor, highlightColor, descriptionColor, backgroundOpacity } = contentData[index];
    return (
        <React.Fragment>
            <section className="section pb-0 hero-section mt-5" id="hero"
                style={{
                    backgroundImage: backgroundImage ? `url(${backgroundImage})` : "none",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "bottom center",
                    backgroundRepeat: "no-repeat",
                    padding: "30px 0",
                    opacity: backgroundOpacity,
                    position: "relative", 
                    minHeight: "600px",
                }}
            >
                <button className="nav-button left" onClick={handlePrev}>
                    <FaChevronLeft />
                </button>
                <button className="nav-button right" onClick={handleNext}>
                    <FaChevronRight />
                </button>
                <Container >
                    <Row className="justify-content-center" style={{ minHeight: "600px" }}>
                        <Col lg={11} sm={11}>
                            <div className="container mt-lg-3 pt-5  " >

                                <div className="row align-items-center">
                                    <motion.div
                                        className="col-lg-6 text-center text-lg-start"
                                        key={index}
                                        initial={{ x: -100, opacity: 0 }}
                                        animate={{ x: 0, opacity: 1 }}
                                        exit={{ x: -100, opacity: 0 }}
                                        transition={{ duration: 1, ease: "easeOut" }}
                                        style={{ paddingTop: index === 1 ? "80px" : image ? "0" : "40px" }}
                                    >
                                        {showSearchBar && (
                                            <div className="mb-3" style={{ position: "relative", display: "inline-block", width: "100%" }}>
                                                <div
                                                    className="form-control search-bar"
                                                    style={{
                                                        width: "100%",
                                                        padding: "4px 12px",
                                                        borderRadius: "20px",
                                                        fontSize: "15px",
                                                        paddingLeft: "30px",
                                                        height: "30px",
                                                        backgroundColor: "#f8f9fa",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        color: "black"
                                                    }}
                                                >
                                                    <FaSearch style={{ marginRight: "8px", color: "black" }} /> {searchPlaceholder}
                                                </div>
                                            </div>
                                        )}
                                        <h1 className="display-7 fw-bold mb-2 lh-base" style={{ color: titleColor, fontSize: "2.7rem" }}>
                                            {title} <br />
                                            <span style={{ color: highlightColor, fontSize: "3rem" }}>{highlight}</span>
                                        </h1>
                                        <motion.p
                                            key={`desc-${index}`}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            exit={{ opacity: 0, y: 20 }}
                                            transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
                                            style={{ maxWidth: "550px", fontStyle: "italic", color: descriptionColor, fontSize: "20px" }}
                                        >
                                            {description}
                                        </motion.p>

                                        {/* <div className="mt-3">
                                            <Link to="/products" className="btn btn-primary" style={{backgroundColor: "rgb(52, 81, 159)", border:"none"}}>
                                                View Products <i className="ri-arrow-right-line align-middle ms-1"></i>
                                            </Link>
                                        </div> */}
                                    </motion.div>

                                    {image && (
                                        <motion.div
                                            className="col-lg-6 text-center"
                                            key={`img-${index}`}
                                            initial={{ x: 100, opacity: 0 }}
                                            animate={{ x: 0, opacity: 1 }}
                                            exit={{ x: 100, opacity: 0 }}
                                            transition={{ duration: 1, ease: "easeOut", delay: 0.2 }}
                                        >
                                            <img
                                                src={image}
                                                alt="Office Supplies"
                                                className="img-fluid"
                                                style={{ maxWidth: "100%", height: index === 1 ? "350px" : "auto", marginTop: index === 1 ? "80px" : "0" }}
                                            />
                                        </motion.div>

                                    )}
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <style jsx>{`
                .nav-button {
                    position: absolute;/* Fixed to screen instead of container */
                    top: 50%;
                    transform: translateY(-50%);
                    background: rgba(0, 0, 0, 0.5);
                    color: white;
                    border: none;
                    padding: 15px;
                    cursor: pointer;
                    border-radius: 50%;
                    font-size: 20px;
                    z-index: 1000;
                    transition: background 0.3s ease;
                }

                .nav-button.left {
                    left: 20px; /* Extreme left */
                }

                .nav-button.right {
                    right: 20px; /* Extreme right */
                }

                .nav-button:hover {
                    background: rgba(0, 0, 0, 0.8);
                }

                @media (max-width: 768px) {
                    .nav-button {
                        padding: 10px;
                        font-size: 18px;
                    }
                    .nav-button.left {
                        left: 5px;
                    }
                    .nav-button.right {
                        right: 5px;
                    }
                }
            `}</style>
        </React.Fragment>
    );
};

export default Home;